import Script from 'next/script'

import { GOOGLE_MAPS_API_KEY } from './constants'

export function GoogleMapsScript() {
  if (!GOOGLE_MAPS_API_KEY) {
    return null
  }

  const source = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places`

  return <Script type='text/javascript' src={source} />
}
